<template>
  <div>
    <div id="chattool" class="text-xs-center">
      <!-- <v-tabs v-model="chattooltype" color="grey lighten-3" :slider-color="$vuetify.theme.primary">
        <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Info') }}</v-tab>
        <v-tab v-if="livechatTheme == 'ticket'" ripple :key="'ticket'" :href="'#ticket'">{{
          $t('Ticket')
        }}</v-tab>
      </v-tabs> -->
    </div>

    <div
      id
      style="overflow-x: hidden; overflow-wrap: break-word; white-space: nowrap; overflow-y: auto; background: rgba(230, 240, 251, 1);"
      v-resize="onResizeToolList"
      :style="{ height: toolListHeight + 'px' }"
      class="custom-scroll"
    >
      <!-- <div v-if="chattooltype == 'ticket'">
        <ticket-list
          v-model="selectedUser.userid"
          :pageid="$store.state.livechat.pageid"
          :key="`ticket_list_${selectedUser.userid}_${selectedUser.type}`"
        ></ticket-list>
      </div>
      <div v-if="chattooltype == 'customer'">
        <livechat-customers
          :theme="livechatTheme"
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-customers>
      </div> -->

      <!-- <div v-if="chattooltype == 'customer'"> -->
      <div>
        <livechat-userinfo
          :theme="livechatTheme"
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-userinfo>
      </div>

      <!-- <div v-else-if="chattooltype == 'conversation'">
        <div class="pa-1 form-control">
          <input type="text" class="form-control" :placeholder="$t('Search')" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LivechatCustomers from './livechat-customers'
import LivechatUserinfo from './livechat-userinfo'
import TicketList from './TicketList'
import api from '@/api'

export default {
  props: ['selectedUser'],
  components: {
    LivechatCustomers,
    TicketList,
    LivechatUserinfo
  },
  data() {
    return {
      chattooltype: 'customer',
      toolListHeight: 0,
      allrentcustomer: [],
      allrentsupplier: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    livechatTheme() {
      return this.$store.state.livechat.theme
    },
    currentPageid() {
      return this.$store.state.livechat.pageid
    }
  },
  mounted() {
    var vm = this
    // if (vm.livechatTheme == 'ticket') {
    //   // vm.chattooltype = 'ticket'
    // }
    vm.onResizeToolList()
  },
  methods: {
    getallrenttransactionlivechat() {
      if (this.selectedUser && this.selectedUser.userid) {
        var data = {
          pageid: this.$store.state.livechat.pageid,
          userid: this.selectedUser.userid
        }
        api.getallrenttransactionlivechat(data, (err, response) => {
          if (response.responsecode == 200) {
            this.allrentcustomer = response.data
            this.allrentsupplier = response.data2
          }
        })
      }
    },
    onResizeToolList: function() {
      var vm = this
      vm.$nextTick(function() {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight -
          document.getElementById('main_toolbar').clientHeight -
          // document.getElementById('chattype').clientHeight -
          40
      })
    }
  },
  watch: {
    selectedUser: function(newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.custom-scroll::-webkit-scrollbar-track {
  background-color: #e6f0fb;
}

.custom-scroll::-webkit-scrollbar-thumb {
  // background-color: #0c2f53;
  background-color: #e6f0fb;
  border-radius: 20px;
}
// .custom-scroll::-webkit-scrollbar-thumb:hover {
//   background-color: #0c2f53;
// }
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chattool.vue